var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#81252C",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.001,
    cy: 47.999,
    r: 35.155,
    fill: "#81252C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.493 47.506c.902.52.902 1.822 0 2.342l-16.225 9.368a1.352 1.352 0 0 1-2.028-1.17V39.31a1.352 1.352 0 0 1 2.028-1.171z"
  })));
};
export { SvgPlayButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjUiIGN4PSI0OCIgY3k9IjQ4IiByPSI0OCIgZmlsbD0iIzgxMjUyQyIvPgo8Y2lyY2xlIGN4PSI0OC4wMDA2IiBjeT0iNDcuOTk4NyIgcj0iMzUuMTU0OSIgZmlsbD0iIzgxMjUyQyIvPgo8cGF0aCBkPSJNNTkuNDkzMyA0Ny41MDY0QzYwLjM5NDcgNDguMDI2OCA2MC4zOTQ3IDQ5LjMyNzkgNTkuNDkzMyA0OS44NDgzTDQzLjI2OCA1OS4yMTYxQzQyLjM2NjYgNTkuNzM2NSA0MS4yMzk4IDU5LjA4NTkgNDEuMjM5OCA1OC4wNDUxTDQxLjIzOTggMzkuMzA5N0M0MS4yMzk4IDM4LjI2ODggNDIuMzY2NiAzNy42MTgzIDQzLjI2OCAzOC4xMzg3TDU5LjQ5MzMgNDcuNTA2NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";